import tinycolor2 from 'tinycolor2';

export const getColor = color => tinycolor2(color);

export const getRandomColor = () => tinycolor2.random();

export const isLightColor = color => tinycolor2(color).isLight();

export const isDarkColor = color => tinycolor2(color).isDark();

export const isValidColor = color => tinycolor2(color).isValid();

export const isWhiteColor = color => tinycolor2(color).toHexString().toLowerCase() === '#ffffff';
